import { Auth } from '@ax/auth';
import { useEffect } from 'react';
import style from './TemplateList.module.scss';
import { Button } from '@ax/ui';
import {
  addNewTemplateRequested,
  discardConfirmationRequested,
  newTemplateDiscarded,
  templateSelected,
  Template,
  templateDeselected,
  RootState,
  useAppSelector,
  loadTemplatesRequested,
  useAppDispatch,
} from '@ax/redux-store';
import useAnalytics from '@/hooks/useAnalytics';
import { NEW_TEMPLATE_TEMP_ID } from '@ax/constants';

export const TemplateList = () => {
  const dispatch = useAppDispatch();
  const analytics = useAnalytics();
  const templateList: Template[] = useAppSelector((state: RootState) => state.templates.items);
  const currentItem: Template = useAppSelector((state: RootState) => state.templates.current);
  const editedTemplate = useAppSelector((state: RootState) => state.templates.editedTemplate);
  const providerId = Auth.currentUser()?.uid;

  useEffect(() => {
    dispatch(loadTemplatesRequested({ providerId }));
  }, []);

  const onTemplateSelect = (template: Template) => {
    if (currentItem?.id === NEW_TEMPLATE_TEMP_ID) {
      dispatch(
        discardConfirmationRequested({
          postDiscardActions: [
            templateDeselected({ template: currentItem }),
            templateSelected({ template }),
            newTemplateDiscarded({ template: currentItem }),
          ],
        }),
      );

      return;
    }

    if (
      currentItem?.id !== NEW_TEMPLATE_TEMP_ID &&
      editedTemplate?.isEditing &&
      currentItem?.id === editedTemplate?.templateId
    ) {
      dispatch(
        discardConfirmationRequested({
          postDiscardActions: [
            templateDeselected({ template: currentItem }),
            templateSelected({ template }),
          ],
        }),
      );
      return;
    }

    dispatch(templateDeselected({ template: currentItem }));
    dispatch(templateSelected({ template }));
  };

  const handleAddTemplate = () => {
    dispatch(addNewTemplateRequested({ providerId }));
    const analyticsProperties = {
      eventDateTime: new Date()?.toString(),
    };
    analytics.onAddNewTemplate(analyticsProperties);
  };

  return (
    <div className={style.template__list__container}>
      <div className="mx-[10px] mb-[10px]">
        <Button
          disabled={Boolean(templateList.find((template) => template.id === NEW_TEMPLATE_TEMP_ID))}
          label="+ Add new"
          className="font-[600]"
          onClick={handleAddTemplate}
          small
          outline
          block
        />
      </div>
      <div className={style.template__list__items__container}>
        {templateList
          ? templateList.map((template) => (
              <div
                className={`${
                  currentItem?.id === template.id ? style.template__list__item__active : ''
                } ${style.template__list__item}`}
                key={template.id}
                onClick={() => onTemplateSelect(template)}
              >
                {template.title || template.name}
              </div>
            ))
          : null}
      </div>
    </div>
  );
};
